const config = {
  id: 31,
  name: '新人报道',
  type: 1,
  module_code: 'newcomer_report',
  icon: 'icon-tms-newcomer_report',
  font_icon: '&#xe664;',
  style_type: 1,
  link_type: 0,
  property_data: {
    head_img: '',
    offset_y: 50,
    offset_x: 50,
    scale: 50,
    property: '',
    font_key: 'b',
    font_size: 14,
    name: '',
    department: '',
    subDepartment: '',
    nickname: '',
    birthday: '',
    constellation: '',
    hometown: '',
    single: '',
    hobby: '',
    specialty: ''
  }
};
export default config;